var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVideo = function SvgVideo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 16.1448V7.20312C21.9568 6.46878 21.2657 5.99362 20.8769 6.08001C20.4881 6.1664 20.2289 6.33919 20.2289 6.33919L16.4276 8.715V6.68476C16.4276 4.9569 14.6134 5.0001 14.6134 5.0001H3.81425C2.12959 5.0001 2 6.68476 2 6.68476V16.6632C2 18.2614 3.81425 18.3478 3.81425 18.3478H14.6566C16.3413 18.3478 16.4276 16.7064 16.4276 16.7064V14.5897L20.2289 17.0087L20.8769 17.2247C22.1296 17.0087 22 16.1448 22 16.1448ZM14.743 16.2312C14.743 16.4472 14.5702 16.6632 14.311 16.6632H4.11663C3.90065 16.6632 3.68467 16.4904 3.68467 16.2312V7.11673C3.68467 6.90075 3.85745 6.68476 4.11663 6.68476H14.3542C14.5702 6.68476 14.7862 6.85755 14.7862 7.11673V16.2312H14.743ZM20.3153 15.1513L16.4708 12.7323V10.7452L20.3153 8.23984V15.1513Z",
    fill: "#F6564B"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video.efc425d7.svg";
export { ForwardRef as ReactComponent };